import React, { useState, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

import GroupPageShell from "../components/common/GroupPageShell";
import GabbroIntro from "../components/Hamdan Gabbro Qatar/GabbroIntro";
import About from "../components/Hamdan Gabbro Qatar/GabbroAbout";
import QualityAssurance from "../components/Hamdan Gabbro Qatar/QualityAssurance";
import DivisionServices from "../components/common/DivisionServices";

const HamdanGabbroQatar: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [content, setContent] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { t, t_api } = useLanguage();

  useEffect(() => {
    fetch('/api/homepage/content')
      .then(res => res.json())
      .then(data => {
        setContent(data.GabbroQatar || {});
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching gabbro content:', err);
        setLoading(false);
      });
  }, []);

  // ✅ Default tab is INTRO
  const activeTab = searchParams.get("tab") || "intro";

  // ✅ Tabs list
  const menuItems = [
    { id: "intro", label: t('common.intro') },
    { id: "about", label: t('common.about') },
    { id: "services", label: t('common.services') },
    { id: "qa", label: t('common.qa') },
  ];

  // Derived header content
  const headerContent = useMemo(() => ({
    title: t_api(content?.banner_title, content?.banner_title_ar),
    subtitle: t_api(content?.banner_subtitle, content?.banner_subtitle_ar),
    banners: [1, 2].map(i => ({
      image: content?.[`banner_${i}`]
    })).filter(b => b.image)
  }), [content, t_api]);

  if (loading) return <div className="min-h-screen flex items-center justify-center">{t('common.loading')}</div>;

  return (
    <GroupPageShell
      heroContent={headerContent}
      tabs={menuItems}
      activeTab={activeTab}
      onTabChange={(tabId) => setSearchParams({ tab: tabId })}
      disableMotion
    >
      <div className="mt-8">
        {activeTab === "intro" && <GabbroIntro content={{
          ...content,
          intro_title: t_api(content?.intro_title, content?.intro_title_ar),
          intro_desc: t_api(content?.intro_desc, content?.intro_desc_ar),
          points: [1, 2, 3].map(i => ({
            title: t_api(content?.[`intro_pt_${i}_title`], content?.[`intro_pt_${i}_title_ar`]),
            desc: t_api(content?.[`intro_pt_${i}_desc`], content?.[`intro_pt_${i}_desc_ar`])
          })).filter(p => p.title)
        }} />}
        {activeTab === "about" && <About content={{
          ...content,
          about_title: t_api(content?.about_title, content?.about_title_ar),
          about_desc: t_api(content?.about_desc, content?.about_desc_ar),
          points: [1, 2, 3].map(i => ({
            title: t_api(content?.[`about_pt_${i}_title`], content?.[`about_pt_${i}_title_ar`]),
            desc: t_api(content?.[`about_pt_${i}_desc`], content?.[`about_pt_${i}_desc_ar`])
          })).filter(p => p.title)
        }} />}
        {activeTab === "services" && <DivisionServices content={content} />}
        {activeTab === "qa" && <QualityAssurance content={{
          ...content,
          qa_title: t_api(content?.qa_title, content?.qa_title_ar),
          qa_desc: t_api(content?.qa_desc, content?.qa_desc_ar),
          points: [1, 2, 3, 4, 5, 6].map(i => ({
            title: t_api(content?.[`qa_pt_${i}_title`], content?.[`qa_pt_${i}_title_ar`]),
            desc: t_api(content?.[`qa_pt_${i}_desc`], content?.[`qa_pt_${i}_desc_ar`])
          })).filter(p => p.title)
        }} />}
      </div>
    </GroupPageShell>
  );
};

export default HamdanGabbroQatar;
